<template>
    <div class="download-store-img">
        <img class="xl:w-auto lg:w-auto md:w-full" :src="img" alt="Download Store Phone">
    </div>
</template>

<script>
    export default {
        name: "DownloadStoreLeft",
        props: ['img']
    }
</script>

<style scoped>

</style>